const DevDashboard = () => import(/* webpackChunkName: "dev-module" */ '@views/dev_dashboard/DevDashboard');
const TextEditorExample = () => import(/* webpackChunkName: "dev-module" */ '@views/dev_dashboard/views/TextEditorExample.vue');
const IconsExample = () => import(/* webpackChunkName: "dev-module" */ '@views/dev_dashboard/views/IconsExample.vue');

const isDevEnv = process.env.VUE_APP_ENV === 'development' || process.env.VUE_APP_ENV === 'testing';

export default isDevEnv ? [
    {
        path: '/dev_dashboard',
        name: 'dev_dashboard',
        components: { base: DevDashboard }
    },
    {
        path: '/dev_dashboard/text_editor',
        name: 'dev_dashboard.text_editor',
        components: { base: TextEditorExample }
    },
    {
        path: '/dev_dashboard/icons',
        name: 'dev_dashboard.icons',
        components: { base: IconsExample }
    }
] : [];
